import { AutoplayOptions } from 'component-library/content/Video/PlayerInterface'
import { VideoDetails } from 'common/client-data-types/VideoDetails'
import { PlayerEvent, PagePosition, Standard, PlaylistType } from 'common/events/video-event-types'
import { Logger } from 'typescript-log'
import { VideoMetaDTO } from 'publication-types'
import { VideoConfig } from 'common/client/BaseClientConfig'
import { Product } from 'component-library/__product'
import { VideoOptions } from '../PlayerInterface'
import { RenderPlayerOptions } from '../player-render-params'

export const brightcovePlayerWebId = 'g0iOzsBYC'
// Player used for AMP / IA
export const standaloneSwmPlayerBrightcovePlayerID = 'P5PBiNMA1'

export interface PlayerOptions extends RenderPlayerOptions, VideoOptions {
    brightcovePlayerId: string
}

export interface Props {
    logger: Logger
    playerOptions: PlayerOptions

    variant: Standard['videoPlayerVariant']
    onEvent: (event: PlayerEvent) => void

    play: boolean
    currentVideo: VideoDetails
    currentVideoMetadata: VideoMetaDTO
    currentVideoPosition: number
    playlistType: PlaylistType
    pagePosition: PagePosition

    autoplayOptions: AutoplayOptions | false
    autoplayHasCompleted: boolean
    isMuted: boolean

    isFullscreen: boolean

    adPlaying: boolean

    config: VideoConfig
    product: Product
}
